import React from "react";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

// @mui icons
import Icon from "@mui/material/Icon";

const menus = (): CloudPremisePluginMenu[] => {
    return [
        {
            type: "menu_item",
            name: "File Manager",
            key: "files",
            icon: <Icon fontSize="medium">cloud_upload_outlined</Icon>,
            route: "/filemanager/files",
            privacy: "private",
        },
    ];
};

export default menus;